export default __webpack_public_path__ + "static/media/bedplete.7d8c04a3.png";